import { useState, useEffect } from "react";
import { useHttpClient } from "../../../../../shared/hooks/http-hook";
import moment from "moment";
//MUI
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";

import MultiSelect from "../../../fluxoCaixa/components/filtros/MultiSelect";
import "../../../fluxoCaixa/components/filtros/ModalFiltros.scss";

function ModalFiltrosSaidas({
  openModalFiltros,
  handleCloseModalFiltros,
  handleFiltrar,
  saidas,
  filtrosAplicados,
  filtroCaixa,
  filtroCategoria,
  filtroMetodoPagamento,
  clinicaId,
  auth,
}) {
  const [openModal, setOpenModal] = useState(false);
  /* Caixa, categoria e método são de escolha MÚLTIPLA: lista vazia = todos.
     Mesma convenção do `MultiSelect` e do «Pago por», que já era múltiplo. O
     `Array.isArray` protege de filtragens guardadas em texto de uma versão
     anterior — sem ele, o `.includes` passava a comparar letras. */
  const comoLista = (valor) => (Array.isArray(valor) ? valor : []);

  const [categoria, setCategoria] = useState(comoLista(filtroCategoria));
  const [categorias, setCategorias] = useState([]);
  const [caixa, setCaixa] = useState(comoLista(filtroCaixa));
  const [caixas, setCaixas] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [users, setUsers] = useState([]);
  const [radioPagas, setRadioPagas] = useState(
    filtrosAplicados.includes("pagas") ? true : false,
  );
  const [radioNPagas, setRadioNPagas] = useState(
    filtrosAplicados.includes("naoPagas") ? true : false,
  );
  const [emAtraso, setEmAtraso] = useState(
    filtrosAplicados.includes("emAtraso") ? true : false,
  );
  const [showEmAtraso, setShowEmAtraso] = useState(
    !filtrosAplicados.includes("pagas") ? true : false,
  );
  const [comComprovativo, setComComprovativo] = useState(
    filtrosAplicados.includes("comComprovativo") ? true : false,
  );
  const [showComComprovativo, setShowComComprovativo] = useState(
    !filtrosAplicados.includes("naoPagas") ? true : false,
  );

  const { sendRequest } = useHttpClient();

  const formasPagamento = [
    "Todos",
    "Dinheiro",
    "Cheque",
    "Internet banking",
    "Cartão de crédito",
  ];
  const [metodoPagamento, setMetodoPagamento] = useState(
    comoLista(filtroMetodoPagamento),
  );

  /** Lista vazia não filtra; com valores, a despesa tem de ser um deles. */
  const corresponde = (selecionados, valor) =>
    selecionados.length === 0 || selecionados.includes(valor);

  useEffect(() => {
    const fetchCategorias = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/categoriasfinanceiro/clinica/despesa/${clinicaId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
        setCategorias(
          responseData.categoriasFinanceiro.map((cat) => {
            return { id: cat.id, value: cat.categoria };
          }),
        );
      } catch (err) {
        console.error("err", err);
      }
    };

    const fetchCaixas = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/caixas/clinica/${clinicaId}?todas=true`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        );

        setCaixas(
          responseData.caixas.map((cai) => {
            return { id: cai.id, value: cai.caixa };
          }),
        );
      } catch (err) {
        console.error("err", err);
      }
    };

    const fetchUsers = async () => {
      try {
        const responseData = await sendRequest(
          `${process.env.REACT_APP_BACKEND_LINK}/api/users/ativos/${clinicaId}`,
          "GET",
          null,
          {
            Authorization: "Bearer " + auth.token,
          },
        );
        setUsers(
          responseData.users.map((u) => {
            return { id: u.id, value: u.name };
          }),
        );
      } catch (err) {
        console.error("err", err);
      }
    };

    fetchUsers();
    fetchCaixas();
    fetchCategorias();
  }, [auth.token, clinicaId, sendRequest]);

  useEffect(() => {
    setOpenModal(openModalFiltros);
  }, [openModalFiltros]);

  const metodoPagamentoChangeHandler = (valor) => {
    setMetodoPagamento(valor);
  };

  const handlePagasChange = (e) => {
    setRadioPagas(e.target.checked);
    setRadioNPagas(!e.target.checked);
    setEmAtraso(false);
    setShowEmAtraso(false);
    setShowComComprovativo(true);
  };

  const handleNPagasChange = (e) => {
    setRadioNPagas(e.target.checked);
    setRadioPagas(!e.target.checked);
    setShowEmAtraso(true);
    setShowComComprovativo(false);
    setComComprovativo(false);
  };

  const filtrarModalHandler = () => {
    /* Nenhum dos três escolhido.
       Preserva um comportamento que já existia: SEM filtros de caixa, categoria
       e método, as despesas POR PAGAR também entram; com qualquer um deles, só
       as pagas — uma despesa por pagar não tem caixa nem método, logo não
       corresponderia a nada e desapareceria da lista. */
    const semFiltroDeLinha =
      caixa.length === 0 &&
      categoria.length === 0 &&
      metodoPagamento.length === 0;

    let saidasFiltradas = [];
    saidas.forEach((saida) => {
      if (
        selectedUsers.length > 0 &&
        !selectedUsers.includes(saida.pagaPor?._id)
      )
        return;

      /* «Com comprovativo» não estava a filtrar nada.
       *
       * A caixa de seleção existia, o estado existia e o filtro era até
       * anunciado na lista de filtros aplicados — mas nenhuma linha do código
       * olhava para ele. Marcá-la devolvia exatamente a mesma lista, e quem
       * procurava as despesas por documentar não tinha como as encontrar.
       *
       * O comprovativo é um ficheiro anexado: existe quando há
       * `comprovativo.ficheiro`, que é a mesma condição que a tabela usa para
       * mostrar a ligação para o abrir. */
      if (comComprovativo && !saida.comprovativo?.ficheiro) return;

      if (
        (saida.despesaPaga && radioPagas) ||
        (!saida.despesaPaga && radioNPagas) ||
        (!radioPagas && !radioNPagas)
      ) {
        if (
          (!saida.despesaPaga &&
            emAtraso &&
            moment(saida.dataLimitePagamento).isBefore(moment(), "day")) ||
          (!emAtraso &&
            !saida.despesaPaga &&
            !moment(saida.dataLimitePagamento).isBefore(moment(), "day")) ||
          (saida.despesaPaga && !emAtraso) ||
          (!saida.despesaPaga && !emAtraso)
        ) {
          if (
            (saida.despesaPaga &&
              corresponde(caixa, saida.caixa?._id) &&
              corresponde(metodoPagamento, saida.metodoPagamento) &&
              corresponde(categoria, saida.categoria?._id)) ||
            semFiltroDeLinha
          ) {
            saidasFiltradas.push({ ...saida });
          }
        }
      }
    });

    const filtrosApli = [];
    radioPagas && filtrosApli.push("pagas");
    radioNPagas && filtrosApli.push("naoPagas");
    emAtraso && filtrosApli.push("emAtraso");
    comComprovativo && filtrosApli.push("comComprovativo");
    // O «emAtraso» estava aqui duas vezes — cópia a mais, sem efeito.

    handleFiltrar(
      saidasFiltradas,
      filtrosApli,
      caixa,
      categoria,
      metodoPagamento,
      "",
      "modalFiltros",
    );
    handleCloseModalFiltros();
  };

  const resetModalHandler = () => {
    setSelectedUsers([]);
    /* Estes três não estavam a ser repostos: o filtro era limpo mas os campos
       do modal continuavam a mostrar a escolha anterior. */
    setCaixa([]);
    setCategoria([]);
    setMetodoPagamento([]);
    handleFiltrar(saidas, [], null, null, null, "", "modalFiltros");
    handleCloseModalFiltros();
  };

  return (
    <Modal
      open={openModal}
      onClose={handleCloseModalFiltros}
      aria-labelledby="modal-filtros-title"
      aria-describedby="modal-filtros-description"
    >
      <Box className="financeiro__modalFiltros__filtros-modal-box">
        <div className="financeiro__modalFiltros__modal-container">
          {/* Header */}
          <div className="financeiro__modalFiltros__modal-header">
            <div className="financeiro__modalFiltros__modal-title">
              <span className="financeiro__modalFiltros__filter-icon">🔍</span>
              <h2 id="modal-filtros-title">Filtrar por</h2>
            </div>
            <div className="financeiro__modalFiltros__header-actions">
              <button
                className="financeiro__modalFiltros__reset-btn"
                onClick={resetModalHandler}
              >
                ↻ Resetar
              </button>
              <button
                className="financeiro__modalFiltros__close-btn"
                onClick={handleCloseModalFiltros}
              >
                ×
              </button>
            </div>
          </div>

          {/* Content */}
          <div className="financeiro__modalFiltros__modal-content">
            <div className="financeiro__modalFiltros__filters-section">
              {/* Status de Pagamento */}
              <div className="financeiro__modalFiltros__filter-group">
                <h3 className="financeiro__modalFiltros__group-title">
                  Estado de Pagamento
                </h3>
                <div className="financeiro__modalFiltros__checkbox-grid financeiro__modalFiltros__two-cols">
                  <label
                    className={`financeiro__modalFiltros__checkbox-card ${
                      radioPagas ? "financeiro__modalFiltros__active" : ""
                    }`}
                  >
                    <input
                      type="radio"
                      name="estadoRadios"
                      checked={radioPagas}
                      onChange={handlePagasChange}
                    />
                    <div className="financeiro__modalFiltros__checkbox-content">
                      <div className="financeiro__modalFiltros__label-text">
                        Pagas
                      </div>
                      <div className="financeiro__modalFiltros__desc-text">
                        Saídas já pagas
                      </div>
                    </div>
                  </label>

                  <label
                    className={`financeiro__modalFiltros__checkbox-card ${
                      radioNPagas ? "financeiro__modalFiltros__active" : ""
                    }`}
                  >
                    <input
                      type="radio"
                      name="estadoRadios"
                      checked={radioNPagas}
                      onChange={handleNPagasChange}
                    />
                    <div className="financeiro__modalFiltros__checkbox-content">
                      <div className="financeiro__modalFiltros__label-text">
                        Não Pagas
                      </div>
                      <div className="financeiro__modalFiltros__desc-text">
                        Saídas a pagar
                      </div>
                    </div>
                  </label>
                </div>
              </div>

              {/* Filtros Adicionais */}
              <div className="financeiro__modalFiltros__filter-group">
                <h3 className="financeiro__modalFiltros__group-title">
                  Filtros Adicionais
                </h3>
                <div className="financeiro__modalFiltros__checkbox-grid financeiro__modalFiltros__two-cols">
                  {showComComprovativo && (
                    <label
                      className={`financeiro__modalFiltros__checkbox-card ${
                        comComprovativo
                          ? "financeiro__modalFiltros__active"
                          : ""
                      }`}
                    >
                      <input
                        type="checkbox"
                        checked={comComprovativo}
                        onChange={(e) => setComComprovativo(e.target.checked)}
                      />
                      <div className="financeiro__modalFiltros__checkbox-content">
                        <div className="financeiro__modalFiltros__label-text">
                          Com Comprovativo
                        </div>
                        <div className="financeiro__modalFiltros__desc-text">
                          Recibo ou comprovativo anexado
                        </div>
                      </div>
                    </label>
                  )}

                  {showEmAtraso && (
                    <label
                      className={`financeiro__modalFiltros__checkbox-card ${
                        emAtraso ? "financeiro__modalFiltros__active" : ""
                      }`}
                    >
                      <input
                        type="checkbox"
                        checked={emAtraso}
                        onChange={(e) => setEmAtraso(e.target.checked)}
                      />
                      <div className="financeiro__modalFiltros__checkbox-content">
                        <div className="financeiro__modalFiltros__label-text">
                          Em Atraso
                        </div>
                        <div className="financeiro__modalFiltros__desc-text">
                          Vencidas e não pagas
                        </div>
                      </div>
                    </label>
                  )}
                </div>
              </div>

              {/* Pago por - Sempre visível */}
              {users && (
                <div className="financeiro__modalFiltros__selects-grid">
                  <div className="financeiro__modalFiltros__select-field">
                    <label className="financeiro__modalFiltros__select-label">
                      Pago por
                    </label>
                    <MultiSelect
                      options={users}
                      selectedIds={selectedUsers}
                      onChange={setSelectedUsers}
                      placeholder="Todos"
                    />
                  </div>
                </div>
              )}

              {/* Selects - Só aparecem quando "Pagas" está selecionado */}
              {radioPagas && (
                <div className="financeiro__modalFiltros__selects-grid">
                  {/* Caixa */}
                  {caixas && (
                    <div className="financeiro__modalFiltros__select-field">
                      <label className="financeiro__modalFiltros__select-label">
                        Caixa
                      </label>
                      <MultiSelect
                        options={caixas}
                        selectedIds={caixa}
                        onChange={setCaixa}
                        placeholder="Todas"
                      />
                    </div>
                  )}

                  {/* Método de Pagamento */}
                  <div className="financeiro__modalFiltros__select-field">
                    <label className="financeiro__modalFiltros__select-label">
                      Método de pagamento
                    </label>
                    {/* O «Todos» sai da lista: aqui é a ausência de escolha, e
                        não mais uma opção a par das outras. */}
                    <MultiSelect
                      options={formasPagamento
                        .filter((f) => f !== "Todos")
                        .map((f) => ({ id: f, value: f }))}
                      selectedIds={metodoPagamento}
                      onChange={metodoPagamentoChangeHandler}
                      placeholder="Todos"
                    />
                  </div>

                  {/* Categoria */}
                  {categorias && (
                    <div className="financeiro__modalFiltros__select-field">
                      <label className="financeiro__modalFiltros__select-label">
                        Categoria Saída
                      </label>
                      <MultiSelect
                        options={categorias}
                        selectedIds={categoria}
                        onChange={setCategoria}
                        placeholder="Todas"
                      />
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>

          {/* Footer */}
          <div className="financeiro__modalFiltros__modal-footer">
            <button
              className="financeiro__modalFiltros__cancel-btn"
              onClick={handleCloseModalFiltros}
            >
              Fechar
            </button>
            <button
              className="financeiro__modalFiltros__apply-btn"
              onClick={filtrarModalHandler}
            >
              Filtrar
            </button>
          </div>
        </div>
      </Box>
    </Modal>
  );
}

export default ModalFiltrosSaidas;
